import { Link } from 'react-router-dom';
import { Scale, Phone, Mail, MapPin, Facebook, Twitter, Linkedin } from 'lucide-react';
import { firmInfo } from '../mock';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 text-white">
      <div className="container mx-auto px-4 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Firm Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="bg-gold-400/20 p-2 rounded-lg">
                <Scale className="w-6 h-6 text-gold-400" />
              </div>
              <div>
                <h3 className="text-lg font-bold">{firmInfo.name}</h3>
                <p className="text-xs text-gold-400">Immigration Law</p>
              </div>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              Your trusted partner in navigating immigration law with compassion and expertise.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-gold-400">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-300 hover:text-gold-400 transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-300 hover:text-gold-400 transition-colors duration-200">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-300 hover:text-gold-400 transition-colors duration-200">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-300 hover:text-gold-400 transition-colors duration-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-gold-400">Our Services</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Family-Based Immigration</li>
              <li>Citizenship & Naturalization</li>
              <li>DACA (Deferred Action)</li>
              <li>Waivers</li>
              <li>Consular Processing</li>
              <li>Re-Entry Permits</li>
              <li>Travel Documents / Advance Parole</li>
              <li>EAD Employment Documents</li>
              <li>U-Visa Adjustment of Status</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-gold-400">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-gold-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-gray-300">{firmInfo.phone}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-gold-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-gray-300">{firmInfo.email}</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-gold-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-gray-300">{firmInfo.address}</span>
              </li>
            </ul>

            {/* Social Links */}
            <div className="flex space-x-3 mt-6">
              <a
                href="https://www.facebook.com/GMThibeau"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gold-400/20 p-2 rounded-lg hover:bg-gold-400/30 transition-colors duration-200"
              >
                <Facebook className="w-5 h-5 text-gold-400" />
              </a>
              <a
                href="https://x.com/MendozaThibeau"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gold-400/20 p-2 rounded-lg hover:bg-gold-400/30 transition-colors duration-200"
              >
                <Twitter className="w-5 h-5 text-gold-400" />
              </a>
              <a
                href="https://www.linkedin.com/in/gabriela-thibeau-623a8463"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gold-400/20 p-2 rounded-lg hover:bg-gold-400/30 transition-colors duration-200"
              >
                <Linkedin className="w-5 h-5 text-gold-400" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gold-400/20">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} {firmInfo.name}. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-gold-400 transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-gold-400 transition-colors duration-200">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
